import React from 'react';

// Streamed from the existing public S3 bucket (same one that serves lesson animations/images) —
// the mp4 is deliberately NOT in the repo. Local source copy lives in
// frontend/src/media/Onboarding videos/ (gitignored).
const VIDEO_URL = 'https://prod-nova-learning.s3.eu-west-2.amazonaws.com/videos/Walkthrough+vid+-+Diagnostic+Test+%2B+Live+Class.mp4';

/**
 * Public page for the welcome WhatsApp video link (/watch). Plays the walkthrough video
 * showing parents what to expect during the assessment and free trial. The same static
 * URL is sent to every parent (body variable {{4}} of the welcome template).
 */
export default function Watch() {
  return (
    <div style={{ maxWidth: 720, margin: '40px auto', padding: 24, textAlign: 'center', fontFamily: 'Arial, sans-serif' }}>
      <h2>What to expect in your assessment and free trial</h2>
      <p>Watch this short video before your child's assessment.</p>
      <video
        src={VIDEO_URL}
        controls
        playsInline
        preload="metadata"
        style={{ width: '100%', borderRadius: 8, backgroundColor: '#000' }}
      >
        Your browser does not support video playback.
        <a href={VIDEO_URL}>Download the video instead.</a>
      </video>
    </div>
  );
}
